module.exports = __webpack_public_path__ + "img/super_hero.3abf953a.gif";